module.exports = __webpack_public_path__ + "ae30459093caa2505e329dc475616860.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/GM.svg
// module id = joXL
// module chunks = 0